// WelcomeModal.jsx
import React from 'react';
import { Modal, Typography } from 'antd';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import headerImg from '../../../assets/images/sparkle-banner.jpg'; // Import the image
import { StyledButton } from '../../../components/Button/styled';

const { Title, Paragraph } = Typography;

// Styled component for the modal content
const ModalContent = styled.div`
    text-align: left;
    justify-self: center;
    padding: 10px 0; 
`;

// Styled component for the header image
const HeaderImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const WelcomeModal = ({ showModal, handleClose }) => {
    return (
        <Modal
            visible={showModal}
            onCancel={handleClose}
            footer={[
                <StyledButton key="get-started" type="primary" onClick={handleClose}>
                    Get Started
                </StyledButton>,
            ]}
            centered
            width={600}
            closeIcon={<motion.span whileHover={{ rotate: 90 }}>✖️</motion.span>}
            // Optionally, remove the default title if you're handling it manually
            title={null}
            styles={{
                body: { padding: '0' }, // Replaces deprecated 'bodyStyle'
            }}
        >
            {/* Header Image */}
            <HeaderImage src={headerImg} alt="Welcome Header" />

            {/* Animated Title */}
            <motion.div initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
                <Title level={2} style={{ textAlign: 'left', margin: '20px 0 0' }}>Welcome to Sparkle!</Title>
            </motion.div>

            {/* Modal Content */}
            <ModalContent>
                <Paragraph style={{ fontSize: '18px' }}>
                    Our mission is to empower creators like you to thrive independently. We provide the tools
                    and support you need to transform your creativity into a successful business.
                </Paragraph>
                <Paragraph style={{ fontSize: '18px' }}>
                    With Sparkle, effortlessly showcase all your links, making it easy for your audience
                    to connect with everything you offer. Let&apos;s get started on your journey to success!
                </Paragraph>
            </ModalContent>
        </Modal>
    );
};
